export default function Terms() {
	return (
		<div className="container py-12">
			<h1 className="text-3xl font-bold">Terms of Use</h1>
			<p className="mt-4 text-gray-600">Coming soon.</p>
		</div>
	);
}
